// extracted by mini-css-extract-plugin
export default {"form":"styles_form__uUAhS","container":"styles_container__leoTk","buttonWrapper":"styles_buttonWrapper__PYgtA"};